import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/download-new.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-b40cfb7a")

_pushScopeId("data-v-b40cfb7a")
const _hoisted_1 = {
  key: 1,
  class: "w-full"
}
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap py-6" }
const _hoisted_3 = { class: "flex capitalize mt-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "flex gap-y-6 flex-row flex-wrap py-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_7 = { class: "flex gap-y-6 flex-row flex-wrap py-6" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "overflow-ellipsis text-left" }
const _hoisted_10 = { class: "truncate text-gray-lp-600 w-32" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "overflow-ellipsis text-left" }
const _hoisted_13 = { class: "truncate text-gray-lp-600 w-32" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_15 = { class: "overflow-ellipsis text-left" }
const _hoisted_16 = { class: "truncate text-gray-lp-600 w-32" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "flex flex-row justify-between items-center py-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px font-semibold" }, " Bukti Transfer ", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, "Download", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "download"
}, null, -1)
const _hoisted_22 = { class: "w-full mt-2 flex justify-center border-2 border-dashed border-gray-lp-400 rounded-md" }
const _hoisted_23 = { class: "flex flex-row justify-end space-x-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DownloadAttachment = _resolveComponent("DownloadAttachment")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    title: "Detail Top Up",
    onClose: _ctx.onClose,
    showFooter: 
      _ctx.detailData.tumStatus === 'verified' && _ctx.permissionCheck && !_ctx.isError
    
  }, {
    content: _withId(() => [
      (!_ctx.isLoading && _ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause
          }, null, 8, ["errorType"]))
        : (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "ID",
                value: _ctx.detailData.tumId
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Genesis Transaksi ID",
                value: _ctx.detailData.genesisTransactionId
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Nama Partner",
                value: _ctx.detailData.tumActorName
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Status"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", {
                      class: _ctx.onChipStatus(_ctx.detailData.tumStatus)
                    }, _toDisplayString(_ctx.detailData.tumStatus), 3)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Jumlah Permintaan",
                value: _ctx.formatPriceRP(_ctx.detailData.tumAmount)
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Jumlah Terverifikasi",
                value: 
              _ctx.detailData.tumVerifiedAmount
                ? _ctx.formatPriceRP(_ctx.detailData.tumVerifiedAmount)
                : '-'
            
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-full",
                label: "Jumlah Disetujui",
                value: 
              _ctx.detailData.tumApprovedAmount &&
              _ctx.detailData.tumStatus !== 'verified'
                ? _ctx.formatPriceRP(_ctx.detailData.tumApprovedAmount)
                : '-'
            
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-full",
                label: "Alasan Penolakan",
                value: _ctx.detailData.tumRejectReason
              }, null, 8, ["value"])
            ]),
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Title, {
                class: "w-1/2 pb-1",
                label: "Detail Rekening Pengirim"
              }),
              _createVNode(_component_Title, {
                class: "w-1/2 pb-1",
                label: "Detail Rekening Penerima"
              }),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Nama Bank",
                value: _ctx.detailData.tumSenderBankName
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Nama Bank",
                value: _ctx.detailData.tumRecepientBankName
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Nama Rekening",
                value: _ctx.detailData.tumSenderBankAccountName
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Nama Rekening",
                value: _ctx.detailData.tumRecepientBankAccountName
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "No. Rekening",
                value: _ctx.detailData.tumSenderBankAccountNumber
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "No. Rekening",
                value: _ctx.detailData.tumRecepientBankAccountNumber
              }, null, 8, ["value"])
            ]),
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Tanggal Transaksi"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.formatDateWithoutTime(_ctx.detailData.tumCreatedAt)) + " ", 1),
                      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.detailData.tumCreatedName), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Tanggal Verifikasi"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.formatDateWithoutTime(_ctx.detailData.tumVerificationAt)) + " ", 1),
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.detailData.tumVerificationName), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                class: "w-full",
                label: "Tanggal Persetujuan"
              }, {
                default: _withId(() => [
                  (_ctx.detailData.status !== 'verified')
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithoutTime(_ctx.detailData.tumApprovalAt)) + " ", 1),
                          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.detailData.tumApprovalName), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  (!_ctx.isFilePdf)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args))),
                        class: "text-12px flex flex-row items-center space-x-2 text-red-lp-100 cursor-pointer"
                      }, [
                        _hoisted_20,
                        _hoisted_21
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_22, [
                  (!_ctx.isFilePdf)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: _ctx.detailData.tumFileOfProof,
                        class: "h-64",
                        alt: ""
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_DownloadAttachment, {
                        key: 1,
                        name: _ctx.fileName,
                        url: _ctx.detailData.tumFileOfProof,
                        maxLength: 45
                      }, null, 8, ["name", "url"]))
                ])
              ])
            ])
          ]))
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_lp_button, {
          title: "Reject",
          outline: "",
          textColor: "red-lp-500",
          onClick: _ctx.onReject
        }, null, 8, ["onClick"]),
        _createVNode(_component_lp_button, {
          title: "Approve",
          textColor: "white",
          onClick: _ctx.onApprove
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose", "showFooter"]))
})